import { render, staticRenderFns } from "./AddProblem.vue?vue&type=template&id=6b768c96&scoped=true&"
import script from "./AddProblem.vue?vue&type=script&lang=js&"
export * from "./AddProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b768c96",
  null
  
)

export default component.exports